/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/Xvs.json';
import { Xvs } from 'libs/contracts/generated/infos/contractTypes';
import { useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetXvsContractInput {
  address: string;
  signerOrProvider: Signer | Provider;
}

export const getXvsContract = ({ signerOrProvider, address }: GetXvsContractInput) =>
  new Contract(address, abi, signerOrProvider) as Xvs;

interface UseGetXvsContractInput {
  passSigner: boolean;
  address: string;
  chainId?: ChainId;
}

export const useGetXvsContract = ({
  passSigner = false,
  address,
  chainId,
}: UseGetXvsContractInput) => {
  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getXvsContract({
            address,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, address],
  );
};
